import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {AuthService} from '../../../../../../chat-common/src/lib/services/auth.service';
import {ProfileComponent} from './profile/profile.component';
import {NgClass, NgIf} from '@angular/common';
import {SubscriptionDetailsComponent} from './subscription-details/subscription-details.component';
import {ConnectWhatsappComponent} from './connect-whatsapp/connect-whatsapp.component';
import {user} from '@angular/fire/auth';
import {UserService} from '../../../../../../chat-common/src/lib/services/user.service';
import {APP_ENVIRONMENT} from '../../../../../../chat-common/src/lib/services/environment.service';
import { DesktopHeaderComponent, DesktopHeaderSection } from '../desktop-header/desktop-header.component';
import { DesktopFooterComponent } from '../desktop-footer/desktop-footer.component';
import { WhatsappService } from '../../services/whatsapp.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidemenu',
  standalone: true,
  imports: [ProfileComponent, SubscriptionDetailsComponent, ConnectWhatsappComponent, NgIf, NgClass, DesktopHeaderComponent, DesktopFooterComponent],
  templateUrl: './sidemenu.component.html'
})
export class SidemenuComponent implements OnInit {

  @Output()
  onBackClick: EventEmitter<any> = new EventEmitter();
  showProfile = false;
  showSubscription = false;
  showWhatsapp = false;
  whatsappAboutOpen = false;
  isDesktop = false;

  /** Rendered in the mobile footer, e.g. "Health Assistant v5.0.0 (49)". */
  readonly appVersion: string;

  constructor(
    private authService: AuthService,
    protected userService: UserService,
    protected whatsapp: WhatsappService,
    private router: Router,
    @Inject(APP_ENVIRONMENT) environment: any,
  ) {
    this.appVersion = environment.appVersion;
  }

  ngOnInit(): void {
    // Show Profile by default on all screens; previously only on desktop
    this.isDesktop = typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
    if(this.isDesktop) {
      this.openProfile();
    }

    // The cached number is keyed by user id, which may not have been loaded yet
    // when the service was first constructed.
    this.whatsapp.restoreConnectedNumber();
  }

  openProfile() {
    this.showProfile = true;
    this.showSubscription = false;
    this.showWhatsapp = false;
    this.whatsappAboutOpen = false;
  }

  openSubscription() {
    this.showSubscription = true;
    this.showProfile = false;
    this.showWhatsapp = false;
    this.whatsappAboutOpen = false;
  }

  openWhatsapp() {
    this.showWhatsapp = true;
    this.showProfile = false;
    this.showSubscription = false;
    this.whatsappAboutOpen = false;
  }

  openMyData() {
    this.router.navigate(['/report/BCRA']);
  }

  onWhatsappAboutOpenChange(open: boolean) {
    this.whatsappAboutOpen = open;
  }

  onHeaderSectionSelect(section: DesktopHeaderSection) {
    if (section === 'health-assistant') {
      this.onBackClick.emit();
    }
  }

  handleBack() {
    if (window.innerWidth >= 768) {
      this.onBackClick.emit();
      return;
    }

    if (this.showProfile) {
      this.showProfile = false;
    } else if (this.showSubscription) {
      this.showSubscription = false;
    } else if (this.showWhatsapp) {
      this.showWhatsapp = false;
      this.whatsappAboutOpen = false;
    } else {
      this.onBackClick.emit();
    }
  }

  logout() {
    this.authService.signOut();
  }
}
